<template>
  <div id="app">
    <link href="../static/images/favicon.png" rel="shortcut icon" type="image/x-icon">
    <router-view
      :user="user"
      :user-level="user_level"
      :current-project="current_project"
      @login="signInWithGoogle"
      @set-current-project="setCurrentProject"
    />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { db } from './main'

export default {
  name: 'App',
  beforeCreate: function () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user
        let userLevel = 4
        let that = this
        db.collection('user').doc(user.uid).get().then(function (doc) {
          if (doc.exists) {
            userLevel = doc.data().user_level
            return userLevel
          }
        }).then(function (userLevel) {
          that.user_level = userLevel
          // user login success
          // that.$notify({
          //   title: 'Welcome Back!',
          //   message: '',
          //   type: 'success',
          //   duration: 2000,
          //   offset: 64
          // })
        }).catch(err => {
          console.warn('user has insufficient permission or can\'t access db', err)
          db.collection('visitor').doc(user.uid).set({
            uid: user.uid,
            name: user.displayName,
            display_level: 'Visitor',
            email: user.email,
            photo_url: user.photoURL
          }).then(function () {
            // console.log('user logged as visitor')
            that.$message({
              showClose: true,
              message: 'Your request has been sent, your can access data after your administrator set you as users',
              type: 'success',
              duration: 0,
              center: true
            })
            that.user_level = 3
          })
        })
      }
    })
  },
  data () {
    return {
      user: null,
      user_level: 4,
      current_project: ''
    }
  },
  methods: {
    signInWithGoogle: function () {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user
      }).catch(err => console.warn(err))
    },
    setCurrentProject: function (projectId) {
      this.current_project = projectId
      let date = new Date()
      let month = String(date.getMonth() + 1)
      if (month.length < 2) {
        month = '0' + month
      }
      let day = String(date.getDate() + 1)
      if (day.length < 2) {
        day = '0' + day
      }
      let year = String(date.getFullYear())
      let formatDate = year + '-' + month + '-' + day

      db.collection('project_list').doc(projectId).update({last_open_date: formatDate})
      db.collection('project').doc(projectId).update({last_open_date: formatDate})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue